import { useEffect } from 'react'
import { renderRoutes } from 'react-router-config'
import { insertIntercom } from '@/utils/'

function UserLayout(props) {
  const { route } = props
  // 初始化Intercom
  useEffect(() => {
    insertIntercom()
  }, [])
  return renderRoutes(route.routes)
}

export default UserLayout
